import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Symbol } from "../GameComponents/Symbol";

@engineComponent(ComponentTypes.DisplayObject)
export class SymbolWild extends Symbol {
    static CaseTransform: string = "TRANSFORM";
    static CaseTransformed: string = "TRANSFORMED";
    public transformed: boolean;
    public multiplier: number;

    constructor() {
        super();

        this.transformed = false;
        this.multiplier = 1;
    }

    goToCase(s: string, emitEvent: boolean = false): void {
        if (s == Symbol.CaseEmpty) {
            this.transformed = false;
        }

        if (this.transformed) {
            if (
                this.multiplier > 1 &&
                this.hasCase(s + "_MULTI_" + this.multiplier + "_" + SymbolWild.CaseTransformed)
            ) {
                s = s + "_MULTI_" + this.multiplier + "_" + SymbolWild.CaseTransformed;
            } else {
                if (this.hasCase(s + "_" + SymbolWild.CaseTransformed)) {
                    s = s + "_" + SymbolWild.CaseTransformed;
                }
            }
        }

        super.goToCase(s, emitEvent);
    }

    clone(): SymbolWild {
        let element: SymbolWild = new SymbolWild();

        element.elements = this.elements.clone();
        element.addChild(element.elements);

        element.name = this.name;
        element.id = this.id;
        element.style = this.style;
        element.offsetX = this.offsetX;
        element.offsetY = this.offsetY;
        element.symbolWidth = this.symbolWidth;
        element.symbolHeight = this.symbolHeight;
        element.visible = this.visible;
        element.case = this.case;
        element.style = this.style;
        element.zIndex = this.zIndex;
        element.type = this.type;
        element.hasWinFrame = this.hasWinFrame;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/SymbolWild.ts
 **/